import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Typography from '@material-ui/core/Typography';

import AddIcon from '@material-ui/icons/Add';
import { AuthContext } from '@jumbo/components/context/AuthContext';
import { Box, Checkbox, CircularProgress, Input, ListItemText, MenuItem, Select, TextField } from '@material-ui/core';
import RefreshToken from 'routes/partials/RefreshToken';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import MultipleCountry from './MultipleCountry';

const useStyles = makeStyles(theme => ({
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },

  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  container: {
    maxHeight: 'calc(100vh - 230px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '400px',
  },
  alignCenter: {
    textAlign: 'center',
  },
  // contentPadding:{
  //   '&.MuiDialogContent-root':{
  //     padding:'8px 62px'
  //   }
  // }
  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Bank = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [countryDocumentType, setCountryDocumentType] = useState('');
  const [documentDescription, setDocumentDescription] = useState('');
  const [documentLanguage, setDocumentLanguage] = useState('ENG');
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allCountry, setAllCountry] = useState([]);
  const [clearCountry, setClearCountry] = useState(false);
  // const [clearCountry, setAllCountry] = useState([]);

  const [message, setMessage] = useState('There is no data');

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const getCountry = async () => {
    await axios
      .get(`/api/v1/public/countries`)
      .then(function(response) {
        setAllCountry(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const clear = () => {
    setCountries([]);
    setDocumentDescription('');
    setCountryDocumentType('');
  };

  const onSubmit = async e => {
    e.preventDefault();

    setLoading(true);
    let data = {
      countryDocumentType,
      documentDescription,
      documentLanguage,
      countries,
    };

    // return console.log(data);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    try {
      let response = await axios({
        url: `/api/v1/private/documents/create`,
        method: 'post',
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // clearStates();
      clear();
      setLoading(false);
      setClearCountry(!clearCountry);
      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCountry();
  }, []);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle}>
        <Grid item md={8}>
          <Typography variant="h2">Create Country Document</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          {/* <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            // onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button> */}
        </Grid>
      </Grid>
      <Paper elevation={3}>
        <Box sx={{ p: 6 }}>
          <Grid container alignItems="center" className={classes.titleStyle} spacing={6}>
            <Grid item md={6}>
              <TextField
                variant="outlined"
                select
                label="Document Type"
                size="small"
                fullWidth
                required
                value={countryDocumentType}
                onChange={e => setCountryDocumentType(e.target.value)}
                className={classes.inputStyle}>
                <MenuItem value="Website_Terms">
                  <Box>Website Terms</Box>
                </MenuItem>
                <MenuItem value="Legal_Agreements">
                  <Box>Legal Agreements</Box>
                </MenuItem>
                <MenuItem value="Complaints_Privacy">
                  <Box>Complaints Privacy</Box>
                </MenuItem>
                <MenuItem value="Modern_Slavery_Policy">
                  <Box>Modern Slavery Policy</Box>
                </MenuItem>
                <MenuItem value="Customer_Vulnerability">
                  <Box>Customer Vulnerability</Box>
                </MenuItem>
                <MenuItem value="Data_Privacy_Statement">
                  <Box>Data Privacy Statement</Box>
                </MenuItem>
                <MenuItem value="Privacy_Policy">
                  <Box>Privacy Policy</Box>
                </MenuItem>
                <MenuItem value="Terms_And_Conditions">
                  <Box>Terms And Conditions</Box>
                </MenuItem>
              </TextField>
            </Grid>
            <Grid item md={6}>
              <TextField
                variant="outlined"
                select
                label="Document Language"
                size="small"
                fullWidth
                required
                value={documentLanguage}
                onChange={e => setDocumentLanguage(e.target.value)}
                className={classes.inputStyle}>
                <MenuItem value="ENG">
                  <Box className={classes.inner}>ENG</Box>
                </MenuItem>
              </TextField>
            </Grid>
            <Grid item md={12}>
              <MultipleCountry
                countries={countries}
                setCountries={setCountries}
                allCountry={allCountry}
                clearCountry={clearCountry}
              />
              {/* <TextField
                variant="outlined"
                select
                label="Country"
                size="small"
                fullWidth
                required
                value={countries}
                onChange={e => {
                  countries.push(e.target.value);
                  // setCountries(e.target.value);
                }}
                className={classes.inputStyle}>
                {allCountry.map((e, index) => (
                  <MenuItem value={e.id} key={index}>
                    <Box className={classes.inner}>
                      <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.name}
                    </Box>
                  </MenuItem>
                ))}
              </TextField> */}
            </Grid>

            <Grid item md={12}>
              <Box>
                <ReactQuill
                  style={{ height: '500px', marginBottom: '40px' }}
                  theme="snow"
                  value={documentDescription}
                  onChange={setDocumentDescription}
                />
              </Box>
            </Grid>
            <Grid item md={12}>
              <Button
                variant="contained"
                className={classes.buttonStyle}
                color="primary"
                disabled={loading}
                // fullWidth
                onClick={onSubmit}>
                {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default Bank;
